import { render, staticRenderFns } from "./planlector.vue?vue&type=template&id=7590de25"
import script from "./planlector.vue?vue&type=script&lang=js"
export * from "./planlector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports